import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export type LbsBank = { value: string; text: string };

export type LbsBanks = LbsBank[];
export interface LbsReducer {
    lbsBankregnr: string | null;
    lbsBanks: LbsBanks;
}

export const initialState: LbsReducer = {
    lbsBankregnr: null,
    lbsBanks: [
        { value: '4484', text: 'Aasen Sparebank' },
        { value: '1100', text: 'Askim & Spydeberg Sparebank' },
        { value: '2635', text: 'Drangedal Sparebank' },
        { value: '4358', text: 'Nidaros Sparebank' },
        { value: '4285', text: 'Selbu Sparebank' },
        { value: '4730', text: 'Sparebank 68 Nord' },
        { value: '2630', text: 'Sparebanken DIN' },
        { value: '4336', text: 'Stadsbygd Sparebank' },
        { value: '1885', text: 'Tolga-Os Sparebank' },
        { value: '4290', text: 'Ørland Sparebank' },
    ],
};

export const lbsReducer = (state = initialState, action: AppActions = {} as AppActions): LbsReducer => {
    switch (action.type) {
        case actionTypes.CHANGE_LBS_BANK: {
            const { bankregnr } = action.payload;
            return {
                ...state,
                lbsBankregnr: bankregnr,
            };
        }

        default:
            return state;
    }
};
